import JoditEditor from "jodit-react";
import { useRef } from "react";
import { config } from "utils/jodit/config";

export const JoditEditorCustom = ({ onBlur, value }) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={config}
      onBlur={onBlur}
    />
  );
};
